<template>
  <div
    class="small-12 medium-12"
    :class="signatureZoneClass"
  >
    <div
      v-for="(name, index) in internalValue"
      :key="index"
      class="row"
    >
      <SignatureField
        v-show="!editStatus"
        ref="signatureRefs"
        :isEditable="!editStatus"
        class="signature-box pointer columns small-6"
        :message="proxySignMsg"
      />
      <div
        class="columns"
      >
        <div
          v-if="editStatus"
          class="row"
        >
          <div class="small-8">
            <HKLInput
              :value="name"
              @change="val => update(val, index)"
            />
          </div>
          <div
            v-if="index === 0"
            class="underline pointer signature__add small-1"
            @click="add"
          >
            {{ $t('action.add') }} +
          </div>
          <div class="small-1">
            <HKLDeleteIcon
              v-if="index !== 0"
              class="signature__del"
              @click="del(index)"
            />
          </div>
        </div>
        <div
          v-else
          :class="signatureNameClass"
        >
          {{ name }}
        </div>
        <span
          :class="hintClass"
          class="signature__zone-text"
        >{{ $t('hotb.signatures.nameInBlockLetter') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, unref, ref } from 'vue-demi'
import HKLInput from '@/controls/Input/HKLInput.vue'
import SignatureField from '@/controls/SignatureField'
import i18n from '@/utils/i18n'
import HKLDeleteIcon from '@/controls/Icon/HKLDeleteIcon.vue'

export default {
  components: {
    SignatureField,
    HKLInput,
    HKLDeleteIcon,
  },
  props: {
    editStatus: Boolean,
    value: {
      type: Array,
      default: () => [''],
    },
    signatureMsg: {
      type: String,
      default: '',
    },
  },
  setup (props, { emit }) {
    const emptyValue = computed(() => props.editStatus ? '' : i18n.t('emptyValue'))
    const internalValue = computed(() => {
      return props.value.map(item => {
        return item || unref(emptyValue)
      })
    })
    const signatureRefs = ref([])
    const update = (val, index) => {
      const cloneNames = [...props.value]
      cloneNames[index] = val
      emit('input', cloneNames)
    }
    const del = (index) => {
      const cloneNames = [...props.value]
      cloneNames.splice(index, 1)
      emit('input', cloneNames)
    }
    const add = () => {
      const cloneNames = [...props.value]
      cloneNames.push('')
      emit('input', cloneNames)
    }
    return {
      signatureRefs,
      internalValue,
      hintClass: computed(() => {
        return props.editStatus ? 'small-8' : 'readonly'
      }),
      signatureNameClass: computed(() => ({'signature__zone-name': !props.editStatus})),
      signatureZoneClass: computed(() => {
        return props.editStatus ? 'large-12' : 'large-8'
      }),
      update,
      add,
      del,
      getSignatures () {
        return unref(signatureRefs).map((item, index) => {
          return {
            name: unref(props.value)[index],
            img: item.imgUrl,
          }
        })
      },
      proxySignMsg: computed(() => {
        return props.signatureMsg ? props.signatureMsg : i18n.t('signature')
      }),
    }
  },
}
</script>

<style lang="scss" scoped>
.signature-box {
  margin-bottom: 10px;
  margin-right:10px;
}
.signature {
  &__zone-name {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  &__zone-text {
    &.readonly {
      border-top: 1px solid black;
    }
    width: 100%;
    font-size: 12px;
    margin-top: 0px;
    font-style: italic;
    text-align: center;
    display: block;
  }
  &__add {
    text-align: center;
    line-height: 40px;
  }
  &__del {
    text-align: center;
    line-height: 40px;
  }
}
</style>
